function requestSearch($this) {
  const $form = $this.parent();
  const formSerialize = $this.serialize() + "*&view=ajax";
  $.ajax({
    url: $form.attr("action"),
    data: formSerialize,
    success: function(data) {
      const $html = $(data);
      const $searchItems = $html.find(".search-box");
      $(".search-items").empty().append($searchItems);
    }
  });
}

var timed;
$(".header .searchform .field").on("keyup", function() {
  const $this = $(this);
  if ($this.val().length >= 3) {
    clearTimeout(timed);
    timed = setTimeout(function() {
      requestSearch($this);
    }, 100);
  }
});



// WEBPACK FOOTER //
// ../assets/js/search.js